module.exports = __webpack_public_path__ + "img/extension_suivi_os.43e97744.png";